import { gql } from "@apollo/client";

export const GET_DASHBOARD = gql`
    query Dashboard($filterInput:DashboardFilterInput!){
        dashboard(filterInput:$filterInput){
            id,
            operation,
            successCount,
            totalCount,
            successAmount,
            successFee,
            netAmount,
            currencyId
        }
    }
`;